''
// DAQI Accessibility - Template Constants
// Extracted to reduce file size and improve maintainability

// Welsh exposure templates for different pollution bands
export const WELSH_EXPOSURE_TEMPLATES = {
  isel: `<h2 class="govuk-heading-m govuk-!-margin-top-6 govuk-!-margin-bottom-4">Sut gallwch chi leihau'ch amlygiad i lygredd aer</h2>
<p>Gall amlygiad hirdymor i lygredd aer (dros flynyddoedd) arwain at lawer o wahanol <a class="govuk-link" href="/lleoliad/{locationId}/effeithiau-iechyd?lang=cy">gyflyrau iechyd</a> a gall leihau disgwyliad oes.</p>
<p>Dylech chi geisio lleihau'ch amlygiad i lygredd aer lle gallwch chi, hyd yn oed pan fo'r lefelau'n isel.</p>
<p>Ystyriwch y camau canlynol:</p>
<ul class="govuk-list govuk-list--bullet">
  <li>cymryd llwybrau lle mae llai o draffig, yn enwedig ar adegau prysur o'r dydd</li>
  <li>cymudo, cerdded neu ymarfer corff mewn parciau neu fannau gwyrdd eraill, os nad yw paill yn effeithio arnoch chi</li>
  <li>os ydych chi'n ymarfer corff dan do, gofalwch fod yr ystafell wedi'i hawyru'n dda</li>
</ul>
<p>Rhagor o gyngor ar <a class="govuk-link" href="/lleoliad/{locationId}/camau-lleihau-amlygiad/cy?lang=cy">gamau y gallwch eu cymryd i leihau'ch amlygiad i lygredd aer</a>.</p>`,
  cymedrol: `<h2 class="govuk-heading-m govuk-!-margin-top-6 govuk-!-margin-bottom-4">Sut gallwch chi leihau'ch amlygiad i lygredd aer</h2>
<p>Ystyriwch y camau canlynol:</p>
<ul class="govuk-list govuk-list--bullet">
  <li>cymryd llwybrau lle mae llai o draffig, yn enwedig ar adegau prysur o'r dydd</li>
  <li>cymudo, cerdded neu ymarfer corff mewn parciau neu fannau gwyrdd eraill, os nad yw paill yn effeithio arnoch chi</li>
  <li>os ydych chi'n ymarfer corff dan do, gofalwch fod yr ystafell wedi'i hawyru'n dda</li>
</ul>
<p>Rhagor o gyngor ar <a class="govuk-link" href="/lleoliad/{locationId}/camau-lleihau-amlygiad/cy?lang=cy">gamau y gallwch eu cymryd i leihau'ch amlygiad i lygredd aer</a>.</p>
<p>Gall amlygiad hirdymor i lygredd aer (dros flynyddoedd) arwain at lawer o wahanol <a class="govuk-link" href="/lleoliad/{locationId}/effeithiau-iechyd?lang=cy">gyflyrau iechyd</a> a gall leihau disgwyliad oes.</p>`,
  uchel: `<h2 class="govuk-heading-m govuk-!-margin-top-6 govuk-!-margin-bottom-4">Sut gallwch chi leihau'ch amlygiad i lygredd aer</h2>
<p>Ystyriwch y camau canlynol:</p>
<ul class="govuk-list govuk-list--bullet">
  <li>cymryd llwybrau lle mae llai o draffig, yn enwedig ar adegau prysur o'r dydd</li>
  <li>cymudo, cerdded neu ymarfer corff mewn parciau neu fannau gwyrdd eraill, os nad yw paill yn effeithio arnoch chi</li>
  <li>os ydych chi'n ymarfer corff dan do, gofalwch fod yr ystafell wedi'i hawyru'n dda</li>
</ul>
<p>Rhagor o gyngor ar <a class="govuk-link" href="/lleoliad/{locationId}/camau-lleihau-amlygiad/cy?lang=cy">gamau y gallwch eu cymryd i leihau'ch amlygiad i lygredd aer</a>.</p>
<p>Gall amlygiad hirdymor i lygredd aer (dros flynyddoedd) arwain at lawer o wahanol <a class="govuk-link" href="/lleoliad/{locationId}/effeithiau-iechyd?lang=cy">gyflyrau iechyd</a> a gall leihau disgwyliad oes.</p>`,
  'uchel iawn': `<h2 class="govuk-heading-m govuk-!-margin-top-6 govuk-!-margin-bottom-4">Sut gallwch chi leihau'ch amlygiad i lygredd aer</h2>
<p>Ystyriwch y camau canlynol:</p>
<ul class="govuk-list govuk-list--bullet">
  <li>cymryd llwybrau lle mae llai o draffig, yn enwedig ar adegau prysur o'r dydd</li>
  <li>cymudo, cerdded neu ymarfer corff mewn parciau neu fannau gwyrdd eraill, os nad yw paill yn effeithio arnoch chi</li>
  <li>os ydych chi'n ymarfer corff dan do, gofalwch fod yr ystafell wedi'i hawyru'n dda</li>
</ul>
<p>Rhagor o gyngor ar <a class="govuk-link" href="/lleoliad/{locationId}/camau-lleihau-amlygiad/cy?lang=cy">gamau y gallwch eu cymryd i leihau'ch amlygiad i lygredd aer</a>.</p>
<p>Gall amlygiad hirdymor i lygredd aer (dros flynyddoedd) arwain at lawer o wahanol <a class="govuk-link" href="/lleoliad/{locationId}/effeithiau-iechyd?lang=cy">gyflyrau iechyd</a> a gall leihau disgwyliad oes.</p>`
}

// English exposure templates for different pollution bands
export const ENGLISH_EXPOSURE_TEMPLATES = {
  low: `<h2 class="govuk-heading-m govuk-!-margin-top-6 govuk-!-margin-bottom-4">How you can reduce your exposure to air pollution</h2>
<p>Long term exposure to air pollution (over years) can lead to many different <a class="govuk-link" href="/location/{locationId}/health-effects?lang=en">health conditions</a> and can reduce life expectancy.</p>
<p>You should try to reduce your exposure to air pollution where you can, even when levels are low.</p>
<p>Consider the following actions:</p>
<ul class="govuk-list govuk-list--bullet">
  <li>take routes where there is less traffic, especially at busy times of day</li>
  <li>commute, walk or exercise in parks or other green spaces, if you are not affected by pollen</li>
  <li>if you exercise indoors, make sure the room is well ventilated</li>
</ul>
<p>Get more advice on <a class="govuk-link" href="/location/{locationId}/actions-reduce-exposure?lang=en">actions you can take to reduce your exposure to air pollution</a>.</p>`,
  moderate: `<h2 class="govuk-heading-m govuk-!-margin-top-6 govuk-!-margin-bottom-4">How you can reduce your exposure to air pollution</h2>
<p>Consider the following actions:</p>
<ul class="govuk-list govuk-list--bullet">
  <li>take routes where there is less traffic, especially at busy times of day</li>
  <li>commute, walk or exercise in parks or other green spaces, if you are not affected by pollen</li>
  <li>if you exercise indoors, make sure the room is well ventilated</li>
</ul>
<p>Get more advice on <a class="govuk-link" href="/location/{locationId}/actions-reduce-exposure?lang=en">actions you can take to reduce your exposure to air pollution</a>.</p>
<p>Long term exposure to air pollution (over years) can lead to many different <a class="govuk-link" href="/location/{locationId}/health-effects?lang=en">health conditions</a> and can reduce life expectancy.</p>`,
  high: `<h2 class="govuk-heading-m govuk-!-margin-top-6 govuk-!-margin-bottom-4">How you can reduce your exposure to air pollution</h2>
<p>Consider the following actions:</p>
<ul class="govuk-list govuk-list--bullet">
  <li>take routes where there is less traffic, especially at busy times of day</li>
  <li>commute, walk or exercise in parks or other green spaces, if you are not affected by pollen</li>
  <li>if you exercise indoors, make sure the room is well ventilated</li>
</ul>
<p>Get more advice on <a class="govuk-link" href="/location/{locationId}/actions-reduce-exposure?lang=en">actions you can take to reduce your exposure to air pollution</a>.</p>
<p>Long term exposure to air pollution (over years) can lead to many different <a class="govuk-link" href="/location/{locationId}/health-effects?lang=en">health conditions</a> and can reduce life expectancy.</p>`,
  'very high': `<h2 class="govuk-heading-m govuk-!-margin-top-6 govuk-!-margin-bottom-4">How you can reduce your exposure to air pollution</h2>
<p>Consider the following actions:</p>
<ul class="govuk-list govuk-list--bullet">
  <li>take routes where there is less traffic, especially at busy times of day</li>
  <li>commute, walk or exercise in parks or other green spaces, if you are not affected by pollen</li>
  <li>if you exercise indoors, make sure the room is well ventilated</li>
</ul>
<p>Get more advice on <a class="govuk-link" href="/location/{locationId}/actions-reduce-exposure?lang=en">actions you can take to reduce your exposure to air pollution</a>.</p>
<p>Long term exposure to air pollution (over years) can lead to many different <a class="govuk-link" href="/location/{locationId}/health-effects?lang=en">health conditions</a> and can reduce life expectancy.</p>`
}

// Health advice messages matching server-side data (fallback only)
export const HEALTH_ADVICE_DATA = {
  low: {
    advice:
      'For most people, short term exposure to low levels of air pollution is not an issue.',
    insetText: `<p>Adults and children with lung or heart conditions are at greater risk of experiencing symptoms.</p>
<p>Symptoms could include:</p>
<ul class="govuk-list govuk-list--bullet">
    <li>coughing</li>
    <li>chest tightness and pain</li>
    <li>difficulty breathing</li>
    <li>worsening of asthma symptoms</li>
    <li>worsening of heart-related symptoms, such as heart palpitations</li>
    <li>worsening of chronic obstructive pulmonary disease (COPD) symptoms</li>
</ul>
<p>Follow your doctor or nurse's usual advice about physically demanding activities and managing your condition.</p>
<p>Follow your agreed management plan if you have one – for example, an asthma action plan. Ask your doctor or nurse for a plan if you do not have one.</p>
<p>Also consider the impact of other triggers on your symptoms – for example, high pollen outside or poor air quality indoors.</p>`,
    atrisk: {
      adults: 'Some people may experience symptoms, even when levels are low.',
      asthma: 'People with asthma should follow their usual management plan.',
      oldPeople:
        'Older people with heart or lung conditions should follow usual advice.'
    }
  },
  moderate: {
    advice:
      'For most people, short term exposure to moderate levels of air pollution is not an issue.',
    insetText: `<p>For most people, short term exposure to moderate levels of air pollution is not an issue. Continue your usual outdoor activities. However, if you are experiencing symptoms, try to reduce your exposure to air pollution.</p>

<h3 class="govuk-heading-s">Short term air pollution exposure</h3>

<p>Short term exposure (over hours or days) can cause a range of health impacts, including:</p>
<ul class="govuk-list govuk-list--bullet">
    <li>coughing</li>
    <li>eye, nose, and throat irritation</li>
    <li>chest tightness and pain</li>
    <li>difficulty breathing</li>
    <li>worsening of asthma symptoms</li>
    <li>worsening of heart-related symptoms, such as heart palpitations</li>
    <li>worsening of chronic obstructive pulmonary disease (COPD) symptoms</li>
</ul>

<p>Symptoms could start within hours or several days after exposure to air pollution.</p>

<p>Speak to your doctor or nurse if:</p>
<ul class="govuk-list govuk-list--bullet">
    <li>you have new symptoms</li>
    <li>your symptoms get worse</li>
    <li>your symptoms do not get better after a week</li>
</ul>

<p>Also consider the impact of other triggers on your symptoms – for example, high pollen outside or poor air quality indoors.</p>

<h3 class="govuk-heading-s">Advice for adults and children with lung or heart conditions, and older people</h3>

<p>Try to adapt physically demanding activities outdoors, especially if your symptoms get worse.</p>
<p>Follow your agreed management plan if you have one – for example, an asthma action plan. Ask your doctor or nurse for a plan if you do not have one.</p>`,
    atrisk: {
      adults:
        'Adults who have heart problems and feel unwell should consider doing less strenuous exercise, especially outside.',
      asthma:
        'People with asthma should be prepared to use their reliever inhaler.',
      oldPeople:
        'Older people should consider doing less strenuous activity, especially outside.'
    }
  },
  high: {
    advice:
      'Anyone experiencing discomfort such as sore eyes, cough or sore throat should consider reducing activity, particularly outdoors.',
    insetText: `<p>Try to <a href="/proto-dev-new/actions?locationName">reduce your exposure to air pollution</a>, especially if you're experiencing symptoms.</p>

<h3 class="govuk-heading-s">Short term air pollution exposure</h3>

<p>Short term exposure (over hours or days) can cause a range of health impacts, including:</p>
<ul class="govuk-list govuk-list--bullet">
    <li>coughing</li>
    <li>eye, nose, and throat irritation</li>
    <li>chest tightness and pain</li>
    <li>difficulty breathing</li>
    <li>worsening of asthma symptoms</li>
    <li>worsening of heart-related symptoms, such as heart palpitations</li>
    <li>worsening of chronic obstructive pulmonary disease (COPD) symptoms</li>
</ul>

<p>Symptoms could start within hours or several days after exposure to air pollution.</p>

<p>Speak to your doctor or nurse if:</p>
<ul class="govuk-list govuk-list--bullet">
    <li>you have new symptoms</li>
    <li>your symptoms get worse</li>
    <li>your symptoms do not get better after a week</li>
</ul>

<p>Also consider the impact of other triggers on your symptoms – for example, high pollen outside or poor air quality indoors.</p>

<h3 class="govuk-heading-s">Advice for adults and children with lung or heart conditions, and older people</h3>

<p>You should adapt physically demanding activities outdoors, especially if your symptoms get worse.</p>
<p>Follow your agreed management plan if you have one – for example, an asthma action plan. Ask your doctor or nurse for a plan if you do not have one.</p>`,
    atrisk: {
      adults:
        'Adults with heart problems should reduce strenuous physical exertion, particularly outdoors, especially if they experience symptoms.',
      asthma:
        'People with asthma may find they need to use their reliever inhaler more often.',
      oldPeople: 'Older people should reduce physical exertion.'
    }
  },
  'very high': {
    advice:
      'Reduce physical exertion, particularly outdoors, especially if you experience symptoms such as cough or sore throat.',
    insetText: `<p>Try to <a href="">reduce your exposure to air pollution</a>, especially if you're experiencing symptoms.</p>

<h3 class="govuk-heading-s">Short term air pollution exposure</h3>

<p>Short term exposure (over hours or days) can cause a range of health impacts, including:</p>
<ul class="govuk-list govuk-list--bullet">
    <li>coughing</li>
    <li>eye, nose, and throat irritation</li>
    <li>chest tightness and pain</li>
    <li>difficulty breathing</li>
    <li>worsening of asthma symptoms</li>
    <li>worsening of heart-related symptoms, such as heart palpitations</li>
    <li>worsening of chronic obstructive pulmonary disease (COPD) symptoms</li>
</ul>

<p>Symptoms could start within hours or several days after exposure to air pollution.</p>

<p>Speak to your doctor or nurse if:</p>
<ul class="govuk-list govuk-list--bullet">
    <li>you have new symptoms</li>
    <li>your symptoms get worse</li>
    <li>your symptoms do not get better after a week</li>
</ul>

<p>Also consider the impact of other triggers on your symptoms – for example, high pollen outside or poor air quality indoors.</p>

<h3 class="govuk-heading-s">Advice for adults and children with lung or heart conditions, and older people</h3>

<p>You should adapt physically demanding activities outdoors, especially if your symptoms get worse.</p>
<p>Follow your agreed management plan if you have one – for example, an asthma action plan. Ask your doctor or nurse for a plan if you do not have one.</p>`,
    atrisk: {
      adults:
        'Adults with heart problems should avoid strenuous physical activity.',
      asthma:
        'People with asthma may need to use their reliever inhaler more often.',
      oldPeople: 'Older people should avoid strenuous physical activity.'
    }
  }
}
